import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, Transition as _Transition, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
import Menu from "./Menu";
import Headers from "./Header";
import validates from "@/styles/variables.scss";
import { useStore } from "vuex";
import { computed, ref } from "@vue/reactivity";
import { useRoute } from "vue-router";
import { onMounted } from "vue";
export default {
  __name: 'index',
  setup: function setup(__props) {
    var route = useRoute();
    var store = useStore();
    store.dispatch("tagsView/addCachedView", route);
    var cachedViews = computed(function () {
      return store.getters.cachedViews;
    });
    var activeWidth = computed(function () {
      return store.getters.siderType ? validates.sideBarWidth : validates.hideSideBarWidth;
    });
    onMounted(function () {
      console.log(cachedViews.value);
    });
    return function (_ctx, _cache) {
      var _component_el_aside = _resolveComponent("el-aside");

      var _component_el_header = _resolveComponent("el-header");

      var _component_router_view = _resolveComponent("router-view");

      var _component_el_main = _resolveComponent("el-main");

      var _component_el_container = _resolveComponent("el-container");

      var _directive_loading = _resolveDirective("loading");

      return _withDirectives((_openBlock(), _createBlock(_component_el_container, {
        class: "app-wrapper"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_aside, {
            width: _unref(activeWidth),
            class: "sidebar-container"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_unref(Menu))];
            }),
            _: 1
          }, 8, ["width"]), _createVNode(_component_el_container, {
            class: _normalizeClass(["container", {
              hidderContainer: !_ctx.$store.getters.siderType
            }])
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_header, {
                class: "header"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_unref(Headers))];
                }),
                _: 1
              }), _createVNode(_component_el_main, null, {
                default: _withCtx(function () {
                  return [_createVNode(_component_router_view, null, {
                    default: _withCtx(function (_ref) {
                      var Component = _ref.Component,
                          route = _ref.route;
                      return [_createVNode(_Transition, {
                        name: "fade-transform",
                        mode: "out-in"
                      }, {
                        default: _withCtx(function () {
                          return [(_openBlock(), _createBlock(_KeepAlive, {
                            include: _unref(cachedViews)
                          }, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                            key: route.path
                          }))], 1032, ["include"]))];
                        }),
                        _: 2
                      }, 1024)];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["class"])];
        }),
        _: 1
      })), [[_directive_loading, _ctx.fullscreenLoading, void 0, {
        fullscreen: true,
        lock: true
      }]]);
    };
  }
};